import type {
  PresetColorType,
  PresetStatusColorType,
} from 'antd/es/_util/colors';
import type { LiteralUnion } from 'type-fest';

export const DEACTIVATE_AFTER_X_MONTHS = 6;

export enum VccStatus {
  Inactive = 'INACTIVE',
  Cancelled = 'CANCELLED',
  ToCharge = 'TO_CHARGE',
  Charged = 'CHARGED',
  ToRefund = 'TO_REFUND',
  Deactivated = 'DEACTIVATED',
}

export type VccStatusData = {
  status: VccStatus;
  text: string;
  color: LiteralUnion<PresetColorType | PresetStatusColorType, string>;
  history: string[];
};

export type VccStatusDisplayInfo = {
  text: string;
  color: LiteralUnion<PresetColorType | PresetStatusColorType, string>;
  status: VccStatus;
};
